import React, { Fragment, useEffect } from 'react'
import fetchJSON from 'lib/fetchJSON'
import styles from '../GlobalNav.scss'
import { EventEmitter } from 'events'
import { OrderedMap } from 'immutable'
import { CoreContext } from 'bundles/core/CoreContext'
import { Icon } from 'common/Icon'
import { PopoverLinkMenu, PopoverLinkMenuItem } from 'common/styleguide/PopoverLinkMenu'
import _ from 'lodash'
import cx from 'classnames'
import p from 'prop-types'

// micro flux implementation
const store = new EventEmitter()
store.adminMenuItems = OrderedMap()

// legacy stuff
const legacyMenuItemsFromServer = _.get(window, 'rwgps.config.admin_menu_items', [])

// sort-on-add for better performance
const addOrUpdateAdminMenuItem = (item) => {
  const { menuKey } = item
  store.adminMenuItems = store.adminMenuItems
    .set(menuKey, item)
  store.emit('update', store.adminMenuItems)
}

const removeAdminMenuItem = (menuKey) => {
  store.adminMenuItems = store.adminMenuItems
    .remove(menuKey)
  store.emit('update', store.adminMenuItems)
}

let separatorCount = 0
export const AdminMenuSeparator = () => {
  useEffect(() => {
    const menuKey = `separator_${separatorCount++}`
    addOrUpdateAdminMenuItem({ menuKey, separator: true })
    return () => {
      removeAdminMenuItem(menuKey)
    }
  }, [])
  return null
}

export const AdminMenuItem = ({ menuKey, label, onClick, target, href }) => {
  useEffect(() => {
    addOrUpdateAdminMenuItem({ menuKey, label, onClick, target, href })
    return () => {
      removeAdminMenuItem(menuKey)
    }
  }, [menuKey, href])
  return null
}
AdminMenuItem.propTypes = {
  menuKey: p.string.isRequired,
  label: p.string.isRequired
}

export const AdminMenu = () => <CoreContext.Consumer>
  {isCore => isCore ? <AdminMenuInner /> : null}
</CoreContext.Consumer>

class AdminMenuInner extends React.PureComponent {
  state = {
    hidden: false,
    expanded: false,
    adminMenuItems: OrderedMap()
  }

  componentDidMount () {
    store.on('update', this.onAdminMenuItemsChanged)
    this.setState({ adminMenuItems: store.adminMenuItems })
  }

  componentWillUnmount () {
    store.off('update', this.onAdminMenuItemsChanged)
  }

  onAdminMenuItemsChanged = (adminMenuItems) => {
    this.setState({ adminMenuItems })
  }

  toggleExpanded = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  hide = () => {
    this.setState({ hidden: true })
  }

  render () {
    const { hidden, expanded, adminMenuItems } = this.state
    if (hidden) { return null }

    const uiLabels = adminMenuItems.valueSeq().map(e => e.label).toSet()
    const legacyMenuItemsFromServerToShow = legacyMenuItemsFromServer.filter(i => i && !uiLabels.has(i[0]))

    return (
      <Fragment>
        <a onClick={this.toggleExpanded} className={cx(styles.iconLink, styles.withMargin)} ref={r => { this._ref = r }}>
          <Icon i='ios-settings' size={24} />
        </a>
        {expanded && <PopoverLinkMenu
          target={this._ref}
          placement='bottom'
          onRequestClose={this.toggleExpanded}>
          <PopoverLinkMenuItem
            key={'portal'}
            href={'/admin_portal'}>
            Admin Portal
          </PopoverLinkMenuItem>
          {adminMenuItems.size > 0 && <hr />}
          {adminMenuItems.map((i, k) => (
            <Fragment key={k}>
              {i.separator && <hr />}
              {!i.separator && <PopoverLinkMenuItem
                key={k}
                href={i.href}
                target={i.target}
                onClick={() => { i.onClick && i.onClick(); this.toggleExpanded() }}
                className={i.className}>
                {i.label}
              </PopoverLinkMenuItem>}
            </Fragment>
          )).toIndexedSeq()}
          {legacyMenuItemsFromServerToShow.size > 0 && <hr />}
          {legacyMenuItemsFromServerToShow.map((item, index) =>
            <LegacyAdminMenuItem key={index} item={item} />
          )}
          <hr />
          <PopoverLinkMenuItem onClick={this.hide}>Hide Admin Menu</PopoverLinkMenuItem>
          <PopoverLinkMenuItem onClick={() => fetchJSON('/deadminify', { account_level: 0 }, { method: 'POST' }).then(() => { window.location.reload() })}>Become Starter</PopoverLinkMenuItem>
          <PopoverLinkMenuItem onClick={() => fetchJSON('/deadminify', { account_level: 1 }, { method: 'POST' }).then(() => { window.location.reload() })}>Become Basic</PopoverLinkMenuItem>
          <PopoverLinkMenuItem onClick={() => fetchJSON('/deadminify', { account_level: 2 }, { method: 'POST' }).then(() => { window.location.reload() })}>Become Premium</PopoverLinkMenuItem>
        </PopoverLinkMenu>}
      </Fragment>
    )
  }
}

const LegacyAdminMenuItem = ({ item }) => {
  if (item === null) {
    return null
  }
  const [label, href, linkOptions] = item
  const { method, remote, class: className, ...props } = linkOptions
  return (
    <PopoverLinkMenuItem
      href={href}
      onClick={href ? undefined : () => window.alert('not done yet')}
      data-method={method}
      data-remote={remote}
      className={className}
      {...props}>
      {label}
    </PopoverLinkMenuItem>
  )
}
